/**
 * Animals & nature emoji category with searchable keywords
 */
export const animals = {
  name: 'Animals',
  icon: '🐶',
  emojis: [
    { emoji: '🐶', keywords: ['dog', 'puppy', 'pet', 'cute', 'woof'] },
    { emoji: '🐕', keywords: ['dog', 'pet', 'animal', 'canine', 'pup'] },
    { emoji: '🦮', keywords: ['guide', 'dog', 'service', 'blind', 'assistance'] },
    { emoji: '🐕‍🦺', keywords: ['service', 'dog', 'vest', 'assistance', 'helper'] },
    { emoji: '🐩', keywords: ['poodle', 'dog', 'fancy', 'pet', 'breed'] },
    { emoji: '🐺', keywords: ['wolf', 'howl', 'wild', 'animal', 'pack'] },
    { emoji: '🦊', keywords: ['fox', 'clever', 'cunning', 'animal', 'red'] },
    { emoji: '🦝', keywords: ['raccoon', 'trash', 'panda', 'animal', 'mask'] },
    { emoji: '🐱', keywords: ['cat', 'kitten', 'pet', 'meow', 'cute'] },
    { emoji: '🐈', keywords: ['cat', 'pet', 'feline', 'kitty', 'animal'] },
    { emoji: '🐈‍⬛', keywords: ['black', 'cat', 'halloween', 'pet', 'luck'] },
    { emoji: '🦁', keywords: ['lion', 'king', 'jungle', 'roar', 'mane'] },
    { emoji: '🐯', keywords: ['tiger', 'face', 'stripes', 'wild', 'cat'] },
    { emoji: '🐅', keywords: ['tiger', 'stripes', 'wild', 'animal', 'big'] },
    { emoji: '🐆', keywords: ['leopard', 'spots', 'wild', 'cat', 'fast'] },
    { emoji: '🐴', keywords: ['horse', 'face', 'pony', 'ride', 'stable'] },
    { emoji: '🐎', keywords: ['horse', 'racing', 'ride', 'gallop', 'equine'] },
    { emoji: '🦄', keywords: ['unicorn', 'magic', 'fantasy', 'rainbow', 'horn'] },
    { emoji: '🦓', keywords: ['zebra', 'stripes', 'africa', 'safari', 'animal'] },
    { emoji: '🦌', keywords: ['deer', 'buck', 'antlers', 'forest', 'bambi'] },
    { emoji: '🦬', keywords: ['bison', 'buffalo', 'animal', 'wild', 'american'] },
    { emoji: '🐮', keywords: ['cow', 'moo', 'farm', 'milk', 'cattle'] },
    { emoji: '🐂', keywords: ['ox', 'bull', 'strong', 'farm', 'animal'] },
    { emoji: '🐃', keywords: ['water', 'buffalo', 'animal', 'asia', 'farm'] },
    { emoji: '🐄', keywords: ['cow', 'farm', 'milk', 'cattle', 'dairy'] },
    { emoji: '🐷', keywords: ['pig', 'oink', 'farm', 'cute', 'piggy'] },
    { emoji: '🐖', keywords: ['pig', 'farm', 'animal', 'pork', 'swine'] },
    { emoji: '🐗', keywords: ['boar', 'wild', 'pig', 'tusks', 'animal'] },
    { emoji: '🐽', keywords: ['pig', 'nose', 'snout', 'oink', 'piggy'] },
    { emoji: '🐏', keywords: ['ram', 'sheep', 'horns', 'aries', 'animal'] },
    { emoji: '🐑', keywords: ['sheep', 'lamb', 'wool', 'farm', 'baa'] },
    { emoji: '🐐', keywords: ['goat', 'animal', 'farm', 'horns', 'greatest'] },
    { emoji: '🐪', keywords: ['camel', 'desert', 'hump', 'dromedary', 'animal'] },
    { emoji: '🐫', keywords: ['camel', 'bactrian', 'humps', 'desert', 'animal'] },
    { emoji: '🦙', keywords: ['llama', 'alpaca', 'animal', 'cute', 'spit'] },
    { emoji: '🦒', keywords: ['giraffe', 'tall', 'spots', 'africa', 'neck'] },
    { emoji: '🐘', keywords: ['elephant', 'trunk', 'big', 'memory', 'africa'] },
    { emoji: '🦣', keywords: ['mammoth', 'extinct', 'ice', 'age', 'elephant'] },
    { emoji: '🦏', keywords: ['rhino', 'rhinoceros', 'horn', 'africa', 'animal'] },
    { emoji: '🦛', keywords: ['hippo', 'hippopotamus', 'water', 'africa', 'animal'] },
    { emoji: '🐭', keywords: ['mouse', 'face', 'cute', 'squeak', 'rodent'] },
    { emoji: '🐁', keywords: ['mouse', 'rodent', 'small', 'animal', 'pet'] },
    { emoji: '🐀', keywords: ['rat', 'rodent', 'animal', 'pest', 'mouse'] },
    { emoji: '🐹', keywords: ['hamster', 'pet', 'cute', 'rodent', 'wheel'] },
    { emoji: '🐰', keywords: ['rabbit', 'bunny', 'cute', 'easter', 'hop'] },
    { emoji: '🐇', keywords: ['rabbit', 'bunny', 'hop', 'easter', 'animal'] },
    { emoji: '🐿️', keywords: ['squirrel', 'chipmunk', 'nuts', 'acorn', 'animal'] },
    { emoji: '🦫', keywords: ['beaver', 'dam', 'wood', 'animal', 'tail'] },
    { emoji: '🦔', keywords: ['hedgehog', 'spiny', 'cute', 'sonic', 'animal'] },
    { emoji: '🦇', keywords: ['bat', 'vampire', 'halloween', 'night', 'flying'] },
    { emoji: '🐻', keywords: ['bear', 'teddy', 'animal', 'forest', 'grizzly'] },
    { emoji: '🐻‍❄️', keywords: ['polar', 'bear', 'arctic', 'white', 'cold'] },
    { emoji: '🐨', keywords: ['koala', 'australia', 'cute', 'bear', 'eucalyptus'] },
    { emoji: '🐼', keywords: ['panda', 'bear', 'china', 'bamboo', 'cute'] },
    { emoji: '🦥', keywords: ['sloth', 'slow', 'lazy', 'animal', 'hang'] },
    { emoji: '🦦', keywords: ['otter', 'water', 'cute', 'animal', 'swim'] },
    { emoji: '🦨', keywords: ['skunk', 'smell', 'stink', 'animal', 'spray'] },
    { emoji: '🦘', keywords: ['kangaroo', 'australia', 'hop', 'pouch', 'joey'] },
    { emoji: '🦡', keywords: ['badger', 'animal', 'dig', 'honey', 'forest'] },
    { emoji: '🐾', keywords: ['paw', 'prints', 'pet', 'animal', 'tracks'] },
    { emoji: '🦃', keywords: ['turkey', 'thanksgiving', 'bird', 'gobble', 'animal'] },
    { emoji: '🐔', keywords: ['chicken', 'hen', 'farm', 'bird', 'cluck'] },
    { emoji: '🐓', keywords: ['rooster', 'cock', 'farm', 'crow', 'morning'] },
    { emoji: '🐣', keywords: ['chick', 'hatching', 'baby', 'bird', 'easter'] },
    { emoji: '🐤', keywords: ['chick', 'baby', 'bird', 'cute', 'yellow'] },
    { emoji: '🐥', keywords: ['chick', 'front', 'baby', 'bird', 'cute'] },
    { emoji: '🐦', keywords: ['bird', 'tweet', 'fly', 'animal', 'chirp'] },
    { emoji: '🐧', keywords: ['penguin', 'cold', 'ice', 'bird', 'waddle'] },
    { emoji: '🕊️', keywords: ['dove', 'peace', 'bird', 'white', 'fly'] },
    { emoji: '🦅', keywords: ['eagle', 'bird', 'america', 'fly', 'freedom'] },
    { emoji: '🦆', keywords: ['duck', 'quack', 'bird', 'water', 'waddle'] },
    { emoji: '🦢', keywords: ['swan', 'bird', 'elegant', 'white', 'lake'] },
    { emoji: '🦉', keywords: ['owl', 'bird', 'night', 'wise', 'hoot'] },
    { emoji: '🦤', keywords: ['dodo', 'bird', 'extinct', 'animal', 'mauritius'] },
    { emoji: '🪶', keywords: ['feather', 'bird', 'light', 'quill', 'write'] },
    { emoji: '🦩', keywords: ['flamingo', 'pink', 'bird', 'tropical', 'stand'] },
    { emoji: '🦚', keywords: ['peacock', 'bird', 'feathers', 'colorful', 'display'] },
    { emoji: '🦜', keywords: ['parrot', 'bird', 'tropical', 'talk', 'colorful'] },
    { emoji: '🐸', keywords: ['frog', 'toad', 'ribbit', 'green', 'hop'] },
    { emoji: '🐊', keywords: ['crocodile', 'alligator', 'reptile', 'snap', 'swamp'] },
    { emoji: '🐢', keywords: ['turtle', 'tortoise', 'slow', 'shell', 'reptile'] },
    { emoji: '🦎', keywords: ['lizard', 'reptile', 'gecko', 'animal', 'scale'] },
    { emoji: '🐍', keywords: ['snake', 'reptile', 'slither', 'hiss', 'danger'] },
    { emoji: '🐲', keywords: ['dragon', 'face', 'fantasy', 'chinese', 'myth'] },
    { emoji: '🐉', keywords: ['dragon', 'fantasy', 'myth', 'chinese', 'fire'] },
    { emoji: '🦕', keywords: ['dinosaur', 'sauropod', 'brontosaurus', 'extinct', 'jurassic'] },
    { emoji: '🦖', keywords: ['dinosaur', 'trex', 'tyrannosaurus', 'extinct', 'jurassic'] },
    { emoji: '🐳', keywords: ['whale', 'spouting', 'ocean', 'sea', 'water'] },
    { emoji: '🐋', keywords: ['whale', 'ocean', 'sea', 'humpback', 'marine'] },
    { emoji: '🐬', keywords: ['dolphin', 'ocean', 'sea', 'swim', 'smart'] },
    { emoji: '🦭', keywords: ['seal', 'ocean', 'sea', 'animal', 'marine'] },
    { emoji: '🐟', keywords: ['fish', 'ocean', 'sea', 'swim', 'water'] },
    { emoji: '🐠', keywords: ['fish', 'tropical', 'ocean', 'colorful', 'nemo'] },
    { emoji: '🐡', keywords: ['blowfish', 'puffer', 'fish', 'ocean', 'spiky'] },
    { emoji: '🦈', keywords: ['shark', 'ocean', 'jaws', 'danger', 'fish'] },
    { emoji: '🐙', keywords: ['octopus', 'ocean', 'tentacles', 'sea', 'squid'] },
    { emoji: '🐚', keywords: ['shell', 'beach', 'ocean', 'sea', 'spiral'] },
    { emoji: '🐌', keywords: ['snail', 'slow', 'shell', 'slug', 'garden'] },
    { emoji: '🦋', keywords: ['butterfly', 'insect', 'pretty', 'fly', 'metamorphosis'] },
    { emoji: '🐛', keywords: ['bug', 'caterpillar', 'insect', 'worm', 'crawl'] },
    { emoji: '🐜', keywords: ['ant', 'insect', 'bug', 'colony', 'small'] },
    { emoji: '🐝', keywords: ['bee', 'honey', 'buzz', 'insect', 'sting'] },
    { emoji: '🪲', keywords: ['beetle', 'bug', 'insect', 'scarab', 'crawl'] },
    { emoji: '🐞', keywords: ['ladybug', 'ladybird', 'insect', 'luck', 'red'] },
    { emoji: '🦗', keywords: ['cricket', 'insect', 'chirp', 'grasshopper', 'bug'] },
    { emoji: '🪳', keywords: ['cockroach', 'bug', 'insect', 'pest', 'roach'] },
    { emoji: '🕷️', keywords: ['spider', 'web', 'insect', 'halloween', 'creepy'] },
    { emoji: '🕸️', keywords: ['spider', 'web', 'cobweb', 'halloween', 'sticky'] },
    { emoji: '🦂', keywords: ['scorpion', 'sting', 'desert', 'zodiac', 'danger'] },
    { emoji: '🦟', keywords: ['mosquito', 'bug', 'insect', 'bite', 'pest'] },
    { emoji: '🪰', keywords: ['fly', 'bug', 'insect', 'pest', 'buzz'] },
    { emoji: '🪱', keywords: ['worm', 'earthworm', 'dirt', 'fishing', 'crawl'] },
    { emoji: '🦠', keywords: ['microbe', 'germ', 'bacteria', 'virus', 'covid'] },
  ],
};

export default animals;

